import { render, staticRenderFns } from "./radio-field.vue?vue&type=template&id=5bfc7187&"
import script from "./radio-field.vue?vue&type=script&lang=js&"
export * from "./radio-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports